var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gst-review-purchase-modal-footer u-width-100"},[_c('EventTotalsContainer',{attrs:{"title":_vm.title,"event":_vm.event,"bundle-products":_vm.bundleProducts,"hide-price-breakdown":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }